import { Button } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

const AddButton = styled(Button)({
  margin: '10px',
});

export default AddButton;
